"use client";

import { AlertTriangle, Home, RotateCcw } from "lucide-react";
import { useLocale } from "next-intl";
import Link from "next/link";
import { useEffect } from "react";

/* Route-level error boundary (client) — branded recovery screen */
export default function Error({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) {
  const locale = useLocale();
  const ar = locale === "ar";

  useEffect(() => {
    console.error("[route error]", error);
  }, [error]);

  return (
    <main dir={ar ? "rtl" : "ltr"} className="relative grid min-h-[80vh] place-items-center overflow-hidden bg-[#f6f7fb] p-6">
      <div className="pointer-events-none absolute -top-32 left-1/2 size-[480px] -translate-x-1/2 rounded-full bg-rose-200/40 blur-3xl" />
      <div className="relative w-full max-w-lg overflow-hidden rounded-[32px] border border-slate-100 bg-white p-10 text-center shadow-[0_18px_50px_-20px_rgba(15,23,42,0.18)]">
        <span className="mx-auto grid size-20 place-items-center rounded-3xl bg-rose-50 text-rose-500">
          <AlertTriangle size={40} />
        </span>
        <h1 className="mt-6 text-2xl font-black text-slate-900">{ar ? "حدث خطأ غير متوقع" : "Something went wrong"}</h1>
        <p className="mt-2 text-sm font-semibold leading-relaxed text-slate-400">
          {ar ? "لا تقلق — بياناتك بأمان. جرّب إعادة المحاولة أو الرجوع للوحة التحكم." : "Don't worry — your data is safe. Try again or go back to the dashboard."}
        </p>
        {error?.digest && <p className="mt-3 font-mono text-[10px] text-slate-300" dir="ltr">ref: {error.digest}</p>}
        <div className="mt-8 flex flex-col gap-3 sm:flex-row">
          <button onClick={reset} className="inline-flex flex-1 items-center justify-center gap-2 rounded-2xl bg-gradient-to-br from-[#0d3589] to-[#071f52] py-3 text-sm font-black text-white shadow-lg shadow-[#0d3589]/25 hover:brightness-110">
            <RotateCcw size={16} /> {ar ? "إعادة المحاولة" : "Try again"}
          </button>
          <Link href="/dashboard" className="inline-flex flex-1 items-center justify-center gap-2 rounded-2xl border border-slate-200 py-3 text-sm font-black text-slate-600 hover:bg-slate-50">
            <Home size={16} /> {ar ? "لوحة التحكم" : "Dashboard"}
          </Link>
        </div>
      </div>
    </main>
  );
}
